module.exports = __webpack_public_path__ + "img/step_3-9.4ad32b29.png";